module.exports = __webpack_public_path__ + "static/simple-scatter-737b45979bdea9b5d2730f5c29a9fd63.png";